/**
 * Read blob promise
 * Returns a promise with the blob content as text
 * @param blob
 * @returns string | ArrayBuffer
 */
export const readBlob = (blob: Blob): Promise<string | ArrayBuffer> =>
    new Promise<string | ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('loadend', (e) => {
            const text = e.target.result;
            resolve(text);
        });
        reader.addEventListener('error', (e) => {
            reject(e);
        });
        reader.readAsText(blob, 'UTF-8');
    });
